var map = {
	"./cyberDictation.svg": "8ae5",
	"./es-logo.svg": "565e",
	"./fundBannerDecor.svg": "c830",
	"./fundLodoB.svg": "9766",
	"./fundLogoL.svg": "aa5d",
	"./pravovoiLogo.svg": "5409",
	"./sliderControl.svg": "7bba",
	"./sliderControlColor.svg": "288c",
	"./vppdLogo.svg": "fa33"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "46f5";